export const GET_GENERATED_BLOGS = 'GET_GENERATED_BLOGS';
export const SET_GENERATED_BLOGS = 'SET_GENERATED_BLOGS';
export const ERROR_GENERATED_BLOGS = 'ERROR_GENERATED_BLOGS';